import { createRouter, createWebHistory } from "vue-router";

import LoginAuth from "../components/AuthComponent/LoginAuth.vue";
import NotFound404 from "../components/404NotFound/NotFound404.vue";
import isAuthenticatedGuard from "../auth/guards/is-authenticated.guard";
import redirectUserWithLoginOk from "../auth/guards/redirectUserWithLoginOK.guard";
import isPreCompletedOrderGuard from "../auth/guards/is-pre-completed-order.guard";



    

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            beforeEnter:[redirectUserWithLoginOk], // <-- Arreglar el caso de login/home
            component:  LoginAuth,
        },
        {
            path: '/table-content',
            name: 'table-content',
            beforeEnter:[isAuthenticatedGuard, isPreCompletedOrderGuard], //  <- Descomentar luego de las pruebas
            component:  () => import('../components/TableArticules/TableContent.vue'),
        },
        {
            path: '/order-shipment-data',
            name: 'order-shipment-data',
            beforeEnter:[isAuthenticatedGuard, isPreCompletedOrderGuard],  // <- Descomentar luego de las pruebas
            component:  () => import('../components/OrderShipmentData/OrderShipmentData.vue'),
        },
        {
            path: '/order-detail',
            name: 'order-detail',
            beforeEnter:[isAuthenticatedGuard, isPreCompletedOrderGuard],  // <- Descomentar luego de las pruebas
            component:  () => import('../components/OrderDetail/OrderDetail.vue'),
        },
        {
            path: '/profile',
            name: 'profile',
            beforeEnter: [isAuthenticatedGuard],
            component: () => import('../components/Navbar/Sub-Components/ProfileDetails.vue')
            
        },
        {
            path: '/stock',
            name: 'stock',
            beforeEnter: [isAuthenticatedGuard],
            component: () => import('../components/StockViewDownload/StockDownload.vue')
            
        },
        {
            path: '/tracking',
            name: 'tracking',
            beforeEnter: [isAuthenticatedGuard],
            component: () => import('../components/TrackingShipping/TrackingShipping.vue')
            
        },




        // 404 Not found
        {
            path: '/:pathMatch(.*)*',
            component:  NotFound404,
        }

    ],

    // @ts-ignore
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 };
        }
    }
})



export default router;